import React from 'react';
import T from 'prop-types';
import { CheckOutlined } from '@ant-design/icons';

import SignupButton from '../signupButton';
import ButtonRouter from '../buttonRouter';

const CheckoutButtonStandard = ({ isUserStandard, isUserAdvanced, isUserProfessional, size }) => {
  if (isUserStandard) {
    return (
      <ButtonRouter block icon={<CheckOutlined />} size={size} to="/settings/billing">
        Current Plan
      </ButtonRouter>
    );
  }

  if (isUserAdvanced || isUserProfessional) {
    return (
      <ButtonRouter block size={size} to="/settings/account" type="primary">
        Choose Plan
      </ButtonRouter>
    );
  }

  return <SignupButton block size={size} type="primary" />;
};

CheckoutButtonStandard.propTypes = {
  isUserAdvanced: T.bool.isRequired,
  isUserProfessional: T.bool.isRequired,
  isUserStandard: T.bool.isRequired,

  size: T.string,
};

CheckoutButtonStandard.defaultProps = {
  size: 'large',
};

export default CheckoutButtonStandard;
